import React from 'react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import './styles.css'
// import moment from 'moment'
export default compose(
  inject('i18n'),
  observer
)(({
  _id,
  slug,
  legacy,
  website,
  code,
  name,
  startDate,
  thumbnailUrl,
  location,
  i18n: { locale }
}) => {
  return (
    <div className="eventCardBox">
      <div className="eventCardFinish">
        <img className="eventCardImgFinish" src={thumbnailUrl} alt="" />
        <div className="eventCardDetail">
          <div className="infoRigtSide">
            <span className="eventCardEventTitle">{name[locale]}</span><br />
            <br />
          </div>
          <div className="eventCardRegisterBox">
            <div className="btnWrapper">
              {legacy
                ? website &&
                  <a
                    href={website}
                    className="eventCardRegisterBtn"
                    target="_blank"
                  >
                        Website
                  </a>
                : <Link to={`/events/${slug}`} className="eventCardRegisterBtn">
                  <FormattedMessage id="app.register" defaultMessag="Register" />
                </Link>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/App/EventListPage/EventItem/EventItemRecent.js